(() => {
  const config = document.querySelector("[data-collection-ratings]");
  if (
    !config ||
    config.dataset.mode !== "lightweight" ||
    !config.dataset.apiKey
  )
    return;

  // Fetch all loaded cards. Render only text in existing, contained markup;
  // never call the SDK or measure layout.
  const seen = new WeakSet();
  const cache = new Map();
  const queue = [];
  const updates = new Map();
  let active = 0;
  const number = new Intl.NumberFormat(config.dataset.language || "en", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

  let frame = null;
  const schedule = () => {
    if (frame != null) return;
    frame = requestAnimationFrame(() => {
      frame = null;
      flush();
    });
  };
  const flush = () => {
    // Coalesce responses into a single write phase per animation frame.
    updates.forEach((data, widget) => {
      updates.delete(widget);
      if (!widget.isConnected) return;
      const rating = Number(data?.lipscore) / 2;
      const votes = Number(data?.votes);
      if (
        !Number.isFinite(rating) ||
        rating <= 0 ||
        rating > 5 ||
        !Number.isInteger(votes) ||
        votes <= 0
      )
        return;
      const link = widget.querySelector("a");
      if (!link?.firstChild) return;
      // Keep links on this storefront; do not take URLs from the API.
      const url = new URL(widget.dataset.lsProductUrl, location.origin);
      if (url.origin !== location.origin) return;
      link.firstChild.nodeValue = `★ ${number.format(rating)}`;
      link.setAttribute(
        "aria-label",
        `${number.format(rating)} / 5 (${votes})`,
      );
      link.removeAttribute("aria-hidden");
      link.removeAttribute("tabindex");
    });
    pump();
  };
  const getRating = (id) => {
    if (cache.has(id)) return cache.get(id);
    const url = new URL("https://wapi.lipscore.com/initial_data/products/show");
    url.search = new URLSearchParams({
      api_key: config.dataset.apiKey,
      internal_id: id,
      widgets: "r_sm",
      translate_to_lang: config.dataset.language || "en",
    });
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    const request = fetch(url, {
      signal: controller.signal,
      credentials: "omit",
    })
      .then((response) => (response.ok ? response.json() : null))
      .catch(() => null)
      .finally(() => clearTimeout(timeout));
    cache.set(id, request);
    return request;
  };
  const pump = () => {
    while (active < 4 && queue.length) {
      const widget = queue.shift();
      if (!widget.isConnected) continue;
      active++;
      getRating(widget.dataset.lsProductId)
        .then((data) => {
          if (data && widget.isConnected) updates.set(widget, data);
        })
        .finally(() => {
          active--;
          pump();
          schedule();
        });
    }
  };
  const scan = () => {
    document
      .querySelectorAll(".product-item .collection-card-rating")
      .forEach((widget) => {
        const cart = widget.closest(".quick-cart");
        if (cart && !cart.querySelector(".quick-cart__wrapper.active")) return;
        if (seen.has(widget) || !widget.dataset.lsProductId) return;
        seen.add(widget);
        queue.push(widget);
      });
    pump();
  };
  document.addEventListener("collection:updated", scan);
  document.addEventListener("recently-viewed:updated", scan);
  document.addEventListener("quick-cart:ratings-updated", scan);
  document.addEventListener("shopify:section:load", scan);
  scan();
})();
